import type { ChannelId, PartySlug } from '@mixwire/contracts';

export const partyViewQueryKey = (slug: PartySlug): readonly unknown[] => ['party-view', slug];

export const partyWrappedQueryKey = (slug: PartySlug): readonly unknown[] => [
  'party-wrapped',
  slug,
];

export const partyExportQueryKey = (slug: PartySlug): readonly unknown[] => ['party-export', slug];

export const djViewQueryKey = (slug: PartySlug, channelId: ChannelId): readonly unknown[] => [
  'dj-view',
  slug,
  channelId,
];

export const ACTIVE_PARTIES_QUERY_KEY = ['active-parties'] as const;

export const RESOLVE_PARTY_QUERY_KEY_PREFIX = ['resolve-party'] as const;

export const resolvePartyQueryKey = (name: string): readonly unknown[] => [
  ...RESOLVE_PARTY_QUERY_KEY_PREFIX,
  name,
];

export const suggesterViewQueryKey = (slug: PartySlug): readonly unknown[] => [
  'suggester-view',
  slug,
];

export const suggesterSearchQueryKeyPrefix = (slug: PartySlug): readonly unknown[] => [
  'suggester-search',
  slug,
];

export const suggesterSearchQueryKey = (slug: PartySlug, term: string): readonly unknown[] => [
  ...suggesterSearchQueryKeyPrefix(slug),
  term,
];

export const djSearchQueryKeyPrefix = (
  slug: PartySlug,
  channelId: ChannelId,
): readonly unknown[] => ['dj-search', slug, channelId];

export const djSearchQueryKey = (
  slug: PartySlug,
  channelId: ChannelId,
  term: string,
): readonly unknown[] => [...djSearchQueryKeyPrefix(slug, channelId), term];

export const PAST_PARTIES_QUERY_KEY = ['past-parties'] as const;

export const MY_PARTY_QUERY_KEY = ['my-party'] as const;

export const AUTH_QUERY_KEY = ['auth', 'me'] as const;

export const LISTENING_HISTORY_QUERY_KEY = ['listens'] as const;
